import { useState } from 'react';
import {
  Popover,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
} from '@mui/material';

export default function ContractStatusPopover({
  children,
  title,
  messages = [],
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box
        component="div"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={{
          cursor: 'pointer',
          display: 'inline-block',
          width: 'fit-content',
        }}
      >
        {children}
      </Box>
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          pointerEvents: 'none',
        }}
      >
        <Card>
          <CardHeader title={title} />
          <CardContent sx={{ pt: 0 }}>
            {messages.map((message, index) => (
              <Typography
                key={index}
                variant="body2"
                component="p"
                sx={{ mb: 1 }}
              >
                {message}
              </Typography>
            ))}
          </CardContent>
        </Card>
      </Popover>
    </>
  );
}
